import React from 'react'
import {connect} from 'react-redux'
import {fetchReportSales, setReportSalesInfoText} from '../actions/reportActions'
import { Container, Row, Col, Button, Form, Label } from 'reactstrap';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import moment from 'moment';
//import 'moment/locale/pl';
//import TownsSelect from '../components/TownsSelect'
import 'react-select/dist/react-select.css';

const mapStateToProps = state => {  
  return {
    filter: state.report.salesFilter,    
    agentLogin: state.user.agentLogin,
    companies: state.user.agentCompanies,      
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {  
    onFetchReport: (ownProps, apiRequest) => {
      //dispatch(fetchReportReservations(ownProps.agentLogin, apiRequest))   
      dispatch(setReportSalesInfoText("Wyszukiwanie ..."))
      dispatch(fetchReportSales(apiRequest))   
    },
  }
}

const PERIODS = [
  { value: 'month', label: 'miesiąc', className: 'period' },
  { value: 'week', label: 'tydzień', className: 'period' },
  { value: 'day', label: 'dzień', className: 'period' },
];

class SalesFilter extends React.Component{
  constructor (props) {
    super(props)  
    
    this.state = {
      formClass: props.formClass || 'filterForm',
      
      agentLogin: props.agentLogin,
      
      period: 'month',
      fromDate: moment().add(-1, 'month').startOf('month'),
      toDate: moment(),
      company: null,
      
      onFetchReport: props.onFetchReport,
    };
    if (this.props.filter)
      this.state={
        ...this.state,
        fromDate: moment(this.props.filter.dateFrom),
        toDate: moment(this.props.filter.dateTo),
        period: this.props.filter.period,
        company: this.props.filter.company,
      }
    this.handleChangeFromDate = this.handleChangeFromDate.bind(this);
    this.handleChangeToDate = this.handleChangeToDate.bind(this);
    this.handleChangePeriod = this.handleChangePeriod.bind(this);
    this.handleInputChange=this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);       
  }

  handleChangeFromDate(date) {
    var toDate=this.state.toDate;
    if (date>toDate)
      toDate=date
    this.setState({
      fromDate: date,
      toDate
    });
  }
  handleChangeToDate(date) {
    var fromDate=this.state.fromDate;
    if (date<fromDate)
      fromDate=date
    this.setState({
      toDate: date,
      fromDate
    });
  }
  handleChangePeriod = (selectedOption) => {    
    this.setState({ 
      period: selectedOption.value,      
    });    
  }
  handleChangeCompany = (selectedOption) => {    
    this.setState({ 
      company: (selectedOption ? selectedOption.value : null),
    })
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
    console.log(name + ' -> ' + value);
  }
  
  handleSubmit(event) {
    event.preventDefault();
    this.saveStateToLocalStorage();
    let reportReq={
      dateFrom: this.state.fromDate.format('YYYY-MM-DD'),
      dateTo: this.state.toDate.format('YYYY-MM-DD'),
      period: this.state.period,
      company: this.state.company,

      //agent: this.state.agentLogin,
      agent: this.props.agentLogin,
    }
    //console.log("Search Request", searchReq)
    this.state.onFetchReport(this.state, reportReq)
  }
  
  componentDidMount() {
    //fetchTowns(this.state.agentLogin)
    //this.onGetAllTowns()
    //this.state.onGetAllTowns(this.state);
  }
  componentWillUnmount(){
    this.saveStateToLocalStorage();    
  }
  saveStateToLocalStorage(){
//    localStorage.setItem('townFrom', this.state.townFrom);
//    localStorage.setItem('townTo', this.state.townTo);
  }
  
  render() {
    //console.log(townsFrom, this.state.townsFrom)
    return (  
      <Container fluid={true} className={this.state.formClass}>
      <Form>      
        <Row className="align-items-center">
          <Col xs="12" sm="3">
            <Label>Data początkowa:</Label>
            <DatePicker 
                className="form-control"
                selected={this.state.fromDate}
//                dateFormat="DD-MM-YYYY"                   
                minDate={moment().add(-6, 'month')}
                maxDate={moment()}
                onChange={this.handleChangeFromDate}               
            />
          </Col>
          <Col xs="12" sm="3">
            <Label>Data końcowa:</Label>
            <DatePicker 
                className="form-control"
                selected={this.state.toDate}
//                dateFormat="DD-MM-YYYY"                   
                minDate={moment().add(-6, 'month')}
                maxDate={moment()}
                onChange={this.handleChangeToDate}               
            />
          </Col>
          <Col xs="8" sm="3" lg="2">
            <Label>Okres:</Label>
            <Select
              id="state-select"              
              autoFocus
              options={PERIODS}              
              name="period"              
              value={this.state.period}
              onChange={this.handleChangePeriod}              
              openOnClick={true}
              searchable={true}
              clearable={false}
            />
          </Col>

          <Col xs="8" sm="3" lg="2">
          <Label>Przewoźnik:</Label>        
          <Select
            id="state-select"              
            autoFocus
            options={this.props.companies.map(pos => ({value: pos.loginName, label: pos.shortName}))}
            name="criteria"              
            value={this.state.company}
            placeholder="Wybierz przewoźnika"
            onChange={this.handleChangeCompany}              
            openOnClick={true}
            searchable={true}
            clearable={true}
          />
        </Col>

          <Col xs="12" sm="auto" className="ml-sm-auto">            
            <Button color="danger" size="lg" onClick={this.handleSubmit}>Pokaż raport</Button>   
          </Col>
        </Row>          
      </Form>  
      </Container>
    )
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesFilter)    


// WEBPACK FOOTER //
// ./src/containers/SalesFilter.js